export const STATUS_MESSAGE = {
  301: "description here"
};
